import Modal from "react-bootstrap/Modal";
import { Table, Badge, ProgressBar, Button } from "react-bootstrap";
import { IconFileText, IconChevronRight } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import moment from "moment";
import DynamicPagination from "../../components/DynamicPagination ";

function FbopPdfPopup({ show, onClose, onProductsClick }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const { data: documentData, postData: fetchData } = usePostRequest(
    API_ENDPOINTS.FBOP_LISTING,
  );

  useEffect(() => {
    const payload = { page: page, limit: limit };
    fetchData(payload);
  }, [page, limit]);

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      dialogClassName="modal-xl"
      aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-custom-modal-styling-title">
          FBOP Validated Forms
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="table-responsive">
          <Table className="mb-3 align-middle">
            <thead className="bg-light">
              <tr
                style={{
                  fontSize: "0.85rem",
                  textTransform: "uppercase",
                  color: "#6c757d",
                }}
              >
                <th className="ps-4 py-3">Sr.</th>
                <th className="py-3">Attachment Name</th>
                <th className="py-3">Created Date</th>
                <th className="py-3">Page Count</th>
                <th className="py-3 text-end pe-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              {documentData?.data?.map((doc, index) => {
                return (
                  <tr key={doc.id} style={{ fontSize: "0.95rem" }}>
                    <td className="ps-4 text-muted">{index + 1}.</td>
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <div
                          className="p-2 rounded"
                          style={{
                            backgroundColor: "#eef2ff",
                            color: "#FE6338",
                          }}
                        >
                          <IconFileText size={18} />
                        </div>
                        <span
                          className="fw-medium"
                          style={{ color: "#374151" }}
                        >
                          {doc?.file_name}
                        </span>
                      </div>
                    </td>
                    <td className="ps-4 text-muted">
                      {moment(doc?.created_at).format("MM/DD/YYYY HH:mm")}
                    </td>

                    <td>
                      <Badge
                        bg="light"
                        text="dark"
                        className="px-3 py-2 fw-normal border"
                        style={{
                          borderRadius: "20px",
                          fontSize: "0.85rem",
                        }}
                      >
                        {doc?.total_forms} Pages
                      </Badge>
                    </td>
                    <td className="text-end pe-4">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        className="rounded-pill px-3 py-1 d-inline-flex align-items-center gap-1"
                        style={{
                          fontSize: "0.85rem",
                          borderColor: "#FE6338",
                          color: "#FE6338",
                          backgroundColor: "transparent",
                        }}
                        // onClick={() => navigate(`/fbop-data/${doc.auto_id}`)}
                        onClick={() => onProductsClick(doc?.auto_id)}
                      >
                        Products <IconChevronRight size={14} />
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
        {documentData?.data?.length > 0 && (
          <DynamicPagination
            totalPages={documentData?.pagination?.totalPages}
            currentPage={page}
            onPageChange={handlePageChange}
            limitPerPage={limit}
            onLimitChange={handleLimitChange}
          />
        )}
      </Modal.Body>
    </Modal>
  );
}

export default FbopPdfPopup;
